import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGrupoDTO } from '../dto/grupo.dto';
import { IJwtCredencialesDTO } from '../dto/jwt-credenciales.dto';
import { IJwtRespuestaDTO } from '../dto/jwt-respuesta.dto';
import { IRespuestaTokenDTO } from '../dto/respuesta-token.dto';
import { IJwtPeticion } from '../modelo/jwt-peticion.model';

@Injectable({
  providedIn: 'root'
})
export class SeguridadService {

  private urlEndPoint = environment.urlEndPoint;

  private isUsuarioAutenticado = false;
  private credenciales: IJwtCredencialesDTO | null = null;
  private identidad = new BehaviorSubject<IJwtCredencialesDTO | null>(null);
  private perfil: IGrupoDTO | null = null;
  private sesion = new BehaviorSubject<IGrupoDTO | null>(null);

  constructor(private httpCliente: HttpClient, private router: Router) { }

  // sesion
  
  public getPerfilEnSesion():Observable<IGrupoDTO | null>{
    return this.sesion.asObservable();
  }

  public obtenerOEstablecerPerfilEnSesion(): void {
    if (this.perfil === null) {
      this.getPerfilSesion().subscribe(
        res => {
          this.perfil = res;
          this.sesion.next(this.perfil);
        });
    }
  }

  // Seguridad

  public getAutenticacion(): Observable<IJwtCredencialesDTO | null> {
    return this.identidad.asObservable();
  }

 public  setAutenticacion(): void {
    if (!this.isUsuarioAutenticado) {
      this.getCredenciales().subscribe(
        credenciales => {
          this.credenciales = credenciales;
          this.identidad.next(this.credenciales);
        });
    }
  }


  public isAutenticado(): boolean {
    if (this.credenciales === null) {
      this.isUsuarioAutenticado = false;
    } else {
      this.isUsuarioAutenticado = true;
    }
    return this.isUsuarioAutenticado;
  }

  public obtenerOAutenticar(): void {
    if (!this.isAutenticado()) {
      this.setAutenticacion();
    }
  }

  public hasAutoridad(autoridades: string[], perfil: IGrupoDTO): boolean {

    //console.log(autoridades,perfil);

    if(!autoridades || autoridades.length === 0){
      return false;
    }
    
    if (!perfil || perfil.gru_id.length === 0) {
      return false;
    }

    return autoridades.includes(perfil.gru_id)
  }

  // Relacionado al jwt

  public validarCredenciales(jwtPeticion: IJwtPeticion): Observable<IRespuestaTokenDTO> {
    return this.httpCliente.post<IRespuestaTokenDTO>(`${this.urlEndPoint}/general/validar-credenciales`, jwtPeticion);
  }

  public validarTokenInicioSesionYAutenticar(jwtPeticion: IJwtPeticion, token: string): Observable<IJwtRespuestaDTO> {
    return this.httpCliente.post<IJwtRespuestaDTO>(`${this.urlEndPoint}/general/validar-token-inicio-sesion-y-autenticar`,
      jwtPeticion, { params: { token } });
  }

  public getCredenciales(): Observable<IJwtCredencialesDTO> {
    return this.httpCliente.get<IJwtCredencialesDTO>(`${this.urlEndPoint}/autenticado/credenciales`);
  }

  public getPerfilesDisponibles():Observable<IGrupoDTO[]>{
    return this.httpCliente.get<IGrupoDTO[]>(`${this.urlEndPoint}/autenticado/obtener-perfiles-disponibles`)
  }

  public getPerfilSesion(): Observable<IGrupoDTO> {
    return this.httpCliente.get<IGrupoDTO>(`${this.urlEndPoint}/autenticado/obtener-perfil-sesion`);
  }

  public setPerfilSesion(perfil:IGrupoDTO): Observable<any> {
    return this.httpCliente.post<any>(`${this.urlEndPoint}/autenticado/establecer-perfil-sesion`,perfil );
  }


  public logout(): void {
    this.credenciales = null;
    this.identidad.next(this.credenciales);
    this.removerJwt();
  }

  public setJwt(jwt: string): void {
    this.removerJwt();
    localStorage.setItem('token_certificados_web', jwt);
  }

  public getJwt(): string {
    const jwt = localStorage.getItem('token_certificados_web');
    return jwt === null ? 'fake_token' : jwt;
  }

  public isValidJwt(): boolean {
    const jwt: string = this.getJwt();
    return jwt.split('.').length === 3 && jwt.length > 3 ? true : false;
  }

  public removerJwt(): void {
    localStorage.removeItem('token_certificados_web');
  }


}
